import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'
import { isVideoUploading } from '../helpers/interactive_video_creation'

const interactiveVideoData = state => state.interactiveVideoCreation

const uploadingOverlaySelector = createSelector(
	[ interactiveVideoData ],
	interactiveVideo => {
		const message = isVideoUploading(interactiveVideo) ?
			[`${localize('interactive_video_uploadingOverlay_uploading')} ${interactiveVideo.media.asset.progress}%`]:
			[
				`${localize('interactive_video_uploadingOverlay_processingMessage_1')}`,
				`${localize('interactive_video_uploadingOverlay_processingMessage_2')}`,
			]

		return {
			message,
		}
	}
)

export default uploadingOverlaySelector
